import React from 'react';
import {Link} from 'react-router-dom';
import BottomLink from '../../components/BottomLink';

function RNF() {
  return (
    <div className="bww-page page-work"><div className="bww-section section-case-studies">
    <div className="case-study">
      <h2>Richard Nixon Foundation
      <Link className="cs-nav cs-nav-prev" to="/case-quickenloans">&#9650;</Link>
      <Link className="cs-nav cs-nav-next" to="/case-leadgen">&#9660;</Link>
      </h2>
      <div className="bww-row">
        <img className="bww-col-1up" src="./images/case-studies/rnf-hero.jpg" alt="Nixon Foundation Homepage" />
      </div>

      <div class="bww-legend">

      <p><b>Project:</b> Richard Nixon Foundation</p>
      <p><b>My role:</b> Technical lead / frontend engineer</p>
      <p><b>Team:</b> Desktop & mobile UI designers, two junior engineers, PM, contracted QA engineer team</p>
      </div>

      <h3>Context</h3>
      <p>The Foundation owns the campus/buildings and jointly operates the Library and Museum with the National Archives, serving students, researchers, and the public. </p>

      <p><b>The opportunity</b>: a high-visibility, deadline-driven launch aligned to the reopening of a major, multi-million-dollar museum experience—plus the need to make historically relevant content easier to discover digitally.</p>

      <p><b>My winning idea</b> (that helped secure the work): consolidate fragmented, widely scattered media and artifacts into a single, searchable, taxonomized research hub—so users could browse and search across formats from one place.</p>

      <h3>Hard constraints</h3>

      <ul>
        <li><b>Fixed launch date tied to the opening ceremony</b> (the public announcement positioned the website/app launch to coincide with the museum opening).</li>
        
        <li><b>Messy content reality</b>: materials existed across multiple original sources; formats included images, documents, video, and audio—previously disparate and difficult to consolidate.</li>
                
        <li><b>Editorial usability</b>: WordPress needed to remain familiar for day-to-day publishing while supporting a far richer content model than a typical marketing site.</li>
      </ul>

      <h3>What I did: decisions + executions</h3>

      <ul>
        <li><b>Shaped the product’s information architecture (IA)</b>: translated the research-hub concept into a practical WordPress content model (structured artifacts, metadata, and taxonomy rules) designed for long-term growth—not a one-off campaign. This made it possible to catalog, tag, and browse a wealth of artifacts while keeping publishing approachable for non-engineers.</li>
        
        <li><b>Built the unified discovery experience</b>: implemented the Resource Center browsing + search patterns so users could find and aggregate subject-specific multimedia across sources—turning “needle-in-a-haystack” research into a coherent flow.</li>
        
        <li><b>Engineering leadership under a hard date</b>: broke the work into delivery milestones, drove code review standards, coordinated QA readiness, ran defect triage, and kept design + engineering tightly synchronized as the deadline approached.</li>
        
        <li><b>Integrated specialized media/presentation tools</b>: ensured the platform could reliably present mixed-media content (video/audio/documents) in a cohesive UX, while preserving performance and maintainability across devices.</li>
        
        <li><b>Stakeholder communication</b>: demoed progress early/often, translated technical tradeoffs into non-technical terms, and ensured leadership could evaluate the experience against the museum’s public narrative.</li>
      </ul>

      <h3>Outcomes</h3>
      <ul>
        <li>Shipped a modern, mobile-first experience and a dedicated Resource Center designed to surface unfiltered, subject-specific, multi-media content from multiple original sources, replacing a fragmented ecosystem with a unified hub.</li>
        
        <li>Launched in step with the museum’s reopening timeline (a date-driven delivery where “done” meant “publicly live”).</li>
      </ul>

      <h3>Results</h3>
      <ul>
        <li><b>Research became navigable</b>: users could search and consolidate content that previously lived across multiple sites and was difficult to find, access and consolidate.</li>
                
        <li><b>A platform (not a microsite)</b>: WordPress delivered ongoing flexibility for taxonomy-driven growth, content operations, and future feature expansion—matching the Foundation’s need to keep a large historical body of work continuously discoverable.</li>

        <li><b>Stakeholder-facing delivery under scrutiny</b>: Delivered and publicly presented the platform in a <a className="hilite" href="https://www.c-span.org/video/?c4844066/user-clip-dave-bushnell-nixonfoundationorg" target="_blank">recorded C-SPAN program</a> tied to the museum reopening—showcasing trusted ownership on a reputational, deadline-driven launch, and an engaging ability to communicate technical decisions clearly to non-technical, senior stakeholders.</li>
      </ul>

      <p><b>Tech stack:</b> PHP, wholly customized WordPress, WooCommerce, MySQL, AWS (EC2, RDS, S3, CloudFront), JSON/REST APIs, multilingual content, miscellaneous JavaScript libraries, various integrations, HTML5, CSS3/SASS.</p>
      {/* <img aria-hidden="true" src="https://www.bushnellwebworks.com/anon2020.php?w=rnf" style={{width:'1px',height:'1px',opacity:0}} /> */}
    </div>
    <BottomLink to="/case-leadgen" label="Lead-gen sites" />
    </div>
    </div>
  );
}

export default RNF;
